import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: [],
  filters: {
    search: '',
  },
  pagination: {
    limit: 25,
  },
};

const paginate = async (store, meta = {}) => {
  store.setState((state) => {
    state.app.catalogos.custom_address_comercio_exterior = {
      ...state.app.catalogos.custom_address_comercio_exterior,
      filters: {
        ...state.app.catalogos.custom_address_comercio_exterior.filters,
        ...meta,
      },
      busy: true,
    };
  });

  try {
    const { filters, pagination } = store.state.app.catalogos.custom_address_comercio_exterior;

    const params = {
      ...filters,
      ...meta,
      limit: pagination.limit,
      page: meta.page || 1,
    };

    const response = await Http.get('catalogos/custom-address-comercio-exterior', { params });

    let result = response.data;

    if (result.length === 0) {
      const { search } = params;

      result = [
        {
          id: '7683b916-556a-4ac6-9e1f-e9089e8a066a',
          clave: search,
          colonia: 'Parece ser un código postal extranjero',
          municipio: 'click para agregarlo',
          estado: '',
        },
      ];
    }

    store.setState((state) => {
      state.app.catalogos.custom_address_comercio_exterior = {
        ...state.app.catalogos.custom_address_comercio_exterior,
        busy: false,
        data: result,
        pagination: {
          ...state.app.catalogos.custom_address_comercio_exterior.pagination,
          ...response.meta?.pagination,
          links: undefined,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.app.catalogos.custom_address_comercio_exterior.busy = false;
      state.app.catalogos.custom_address_comercio_exterior.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.app.catalogos.custom_address_comercio_exterior = {
      ...initialState,
    };
  });
};

const CustomAddressComercioExteriorSuggestionsStore = {
  state: () => initialState,
  actions: {
    paginate,
    reset,
  },
};

export default CustomAddressComercioExteriorSuggestionsStore;
